<template>
  <v-chip
    :color="almostEnded || isExpired ? 'red' : 'accent'"
    text-color="white"
    role="status"
    aria-live="polite"
    :aria-label="time"
    class="d-inline-flex align-center"
  >
    <v-icon
      left
      aria-hidden="true"
    >
      fad fa-stopwatch
    </v-icon>
    <span aria-hidden="true">{{ time }}</span>
    <span class="sr-only">{{ time }}</span>
  </v-chip>
</template>

<script>
import { timeLeft } from "@/utils/date.utils";

export default {
  name: "CountDownBadge",
  props: {
    ms: {
        type: Number,
        default: 0,
    },
    text: {
        type: String,
        default: "Field Name...",
    },
  },
  emits: {'expired': null},
  data() {
    return {
        hours: 0,
        minutes: 0,
        seconds: 0,
        days: 0,
        isExpired: false,
        almostEnded: false,
        inteveralId: 0
    }
  },
  computed: {
    time() {
      return this.isExpired
        ? this.$t("components.common.expired")
        : this.days > 0
        ? `${this.$t("components.common.expireDays", {
            days: this.days
          })}`
        : `${this.$t("components.common.expireToday", {
            hours: this.hours,
            minutes: this.minutes,
            seconds: this.seconds
          })}`;
    }
  },
  watch: {
    isExpired() {
      if (this.$props.ms) {
        this.$emit("expired");
      }
    }
  },
  beforeMount() {
    this.makeCounter();
  },
  beforeUnmount() {
    clearTimeout(this.inteveralId);
  },
  methods: {
    makeCounter() {
      clearTimeout(this.inteveralId);
      this.inteveralId = setTimeout(this.createTime.bind(this), 1000);
    },
    createTime() {
      const { d, h, m, s, isExpired } = timeLeft(this.$props.ms);
      this.hours = h;
      this.minutes = m;
      this.seconds = s;
      this.days = d;
      this.isExpired = isExpired;
      if (d === 0 && h === 0 && m <= 30) {
        this.almostEnded = true;
      }
      this.makeCounter();
    }
  }
};
</script>

<style scoped>
    .sr-only {
    position: absolute !important;
    width: 1px; height: 1px;
    padding: 0; margin: -1px;
    overflow: hidden; clip: rect(0, 0, 0, 0);
    white-space: nowrap; border: 0;
    }
</style>
